module.exports = __webpack_public_path__ + "img/p3.23847696.png";